module.exports = __webpack_public_path__ + "img/ic_nav_close_white.e5a27295.svg";